import { render } from "./BrandMiss7zDrava.vue?vue&type=template&id=235dcbfe"
import script from "./BrandMiss7zDrava.vue?vue&type=script&lang=ts"
export * from "./BrandMiss7zDrava.vue?vue&type=script&lang=ts"

import "./BrandMiss7zDrava.vue?vue&type=style&index=0&id=235dcbfe&lang=scss"
script.render = render

export default script